import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchSummaryProgressTerm } from '@apis/performance';
import type { ProgressTermApiData } from '@app-types/summaryApi';
import type { ProgressMetricSelection } from '@constants/progressMetrics';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the Progress Status rate column
 * (GET /api/summary/progress/term). Refetches when ticker/mkt or the selected
 * metric changes; metric selection stays in component state, not the URL.
 */
export const useSummaryProgressTerm = (activeMetric: ProgressMetricSelection) => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<ProgressTermApiData>({
    queryKey: ['summary', 'progress-term', ticker, mkt, activeMetric.key],
    queryFn: () =>
      fetchSummaryProgressTerm({
        ticker: ticker as string,
        mkt: mkt as string,
        metric: activeMetric.metric,
      }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
